<template>
  <v-container class="fill-height" fluid id="recover-password">
    <template v-if="isSala">
      <login-selo :hide-illustration="true">
        <template v-slot:formulario v-if="!recuperado && !mostrarVerificacao">
          <lost-password-form
            @recuperado="(e) => (recuperado = e)"
            @codigo-enviado="onCodigoEnviado"
          ></lost-password-form>
        </template>

        <template v-slot:formulario v-else-if="mostrarVerificacao">
          <div class="verification-container">
            <div class="verification-header">
              <p class="verification-subtitle">
                Enviamos um código de 6 dígitos para
                <strong>{{ emailUsuario }}</strong
                >. Digite o código abaixo para continuar com a alteração da sua
                senha.
              </p>
              <p class="verification-note">
                Não recebeu o código? Verifique sua caixa de spam ou clique em
                "Reenviar código" no formulário.
              </p>
            </div>
            <recover-password-form
              :email="emailUsuario"
              @senha-alterada="onSenhaAlterada"
              @voltar="voltarParaEmail"
            ></recover-password-form>
          </div>
        </template>

        <template v-slot:formulario v-else>
          <div class="success-container">
            <div class="success-icon">✓</div>
            <h4 class="success-title">Solicitação Enviada</h4>
            <p class="success-message">
              Caso o e-mail informado esteja registrado, você receberá uma
              mensagem com as instruções para criar uma nova senha. Verifique
              sua caixa de entrada e a pasta de SPAM.
            </p>
            <v-btn
              color="primary"
              variant="outlined"
              @click="voltarParaEmail"
              class="mt-4"
              size="small"
            >
              Tentar Novamente
            </v-btn>
          </div>
        </template>
      </login-selo>
    </template>

    <v-row v-else>
      <v-col sm="8" offset-sm="2" md="6" offset-md="3" lg="4" offset-lg="4">
        <v-card
          class="modern-card elevation-8"
          v-if="!recuperado && !mostrarVerificacao"
        >
          <v-card-text class="pa-8">
            <div class="text-center mb-2">
              <img :src="logos.logoConstrate" class="logo-image" />
              <h2 class="card-title mt-4">Recuperar Senha</h2>
            </div>
            <lost-password-form
              @recuperado="(e) => (recuperado = e)"
              @codigo-enviado="onCodigoEnviado"
            ></lost-password-form>
          </v-card-text>
        </v-card>

        <v-card class="modern-card elevation-8" v-else-if="mostrarVerificacao">
          <v-card-text class="pa-8">
            <div class="text-center mb-2">
              <img :src="logos.logoConstrate" class="logo-image-small" />
              <p class="verification-subtitle mt-3">
                Enviamos um código de 6 dígitos para
                <strong>{{ emailUsuario }}</strong
                >. Digite o código abaixo para continuar com a alteração da sua
                senha.
              </p>
              <p class="verification-note mb-0">
                Não recebeu o código? Verifique sua caixa de spam ou clique em
                "Reenviar código" no formulário.
              </p>
            </div>
            <recover-password-form
              :email="emailUsuario"
              @senha-alterada="onSenhaAlterada"
              @voltar="voltarParaEmail"
            ></recover-password-form>
          </v-card-text>
        </v-card>

        <v-card class="modern-card elevation-8" v-else>
          <v-card-text class="pa-8 text-center">
            <img :src="logos.logo" class="logo-image-small mb-4" />
            <div class="success-icon-large mb-4">✓</div>
            <h2 class="card-title mb-3">Solicitação Enviada</h2>
            <p class="success-message-large mb-6">
              Caso o e-mail informado esteja registrado, você receberá uma
              mensagem com as instruções para criar uma nova senha. Verifique
              sua caixa de entrada e a pasta de SPAM.
            </p>
            <div class="d-flex gap-3 justify-center">
              <v-btn
                color="primary"
                @click="voltarParaEmail"
                prepend-icon="mdi-arrow-left"
              >
                Tentar Novamente
              </v-btn>
              <v-btn
                variant="outlined"
                @click="$router.push('/login')"
                prepend-icon="mdi-login"
              >
                Voltar ao Login
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LostPasswordForm from "./LostPasswordComponents/Form";
import RecoverPasswordForm from "./LostPasswordComponents/RecoverPasswordForm";
import LoginSelo from "./LoginComponents/LoginSelo";
import { mapGetters } from "vuex";
import verificarTonalidadeCor from "@/helpers/verificarTonalidadeCor";
import { atualUfDefinition } from "@/helpers/utils";

export default {
  computed: {
    ...mapGetters(["isSala", "logos"]),
    corTexto() {
      if (verificarTonalidadeCor(atualUfDefinition.corPrimaria))
        return "rgba(0, 0, 0, 0.6)";

      return "#fff";
    },
  },
  components: {
    LostPasswordForm,
    RecoverPasswordForm,
    LoginSelo,
  },
  data() {
    return {
      payload: {},
      recuperado: false,
      mostrarVerificacao: false,
      emailUsuario: "",
      logo: this.$store.state.logo,
    };
  },
  methods: {
    onCodigoEnviado(email) {
      this.emailUsuario = email;
      this.mostrarVerificacao = true;
    },
    onSenhaAlterada() {
      // Redireciona para login após sucesso
      this.$router.push("/login");
    },
    voltarParaEmail() {
      this.mostrarVerificacao = false;
      this.recuperado = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variables.scss";

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

// Estilos para a versão Selo
.verification-container,
.success-container {
  text-align: center;
}

.verification-header {
  margin-bottom: 24px;
}

.verification-title,
.success-title {
  color: #2a4fd7;
  font-weight: 700;
  margin-bottom: 8px;
  font-size: 18px;
}

.verification-subtitle {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
}

.verification-note {
  color: #9ca3af;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 8px;
  font-style: italic;
}

.success-icon {
  width: 50px;
  height: 50px;
  background: #10b981;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  margin: 0 auto 16px;
  animation: successPulse 2s ease-in-out infinite;
}

.success-message {
  color: #6b7280;
  line-height: 1.6;
  font-size: 14px;
  margin-bottom: 0;
}

// Estilos para a versão genérica
.modern-card {
  border-radius: 20px;
  background: white !important;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
}

.logo-image {
  max-width: 280px;
  height: auto;
  background: var(--corPrimaria, #1976d2);
  border-radius: 16px;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.logo-image-small {
  max-width: 200px;
  height: auto;
  background: var(--corPrimaria, #1976d2);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.card-title {
  color: var(--corPrimaria);
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 8px;
}

.card-subtitle {
  color: var(--corSecundaria);
  font-size: 14px;
  margin-bottom: 0;
}

.success-icon-large {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  margin: 0 auto;
  animation: successPulse 2s ease-in-out infinite;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
}

.success-message-large {
  color: #4b5563;
  line-height: 1.6;
  font-size: 16px;
  max-width: 400px;
  margin: 0 auto;
}

@keyframes successPulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 30px rgba(16, 185, 129, 0.4);
  }
}

// Estilos para a versão Selo
.verification-container,
.success-container {
  text-align: center;
}

.verification-header {
  margin-bottom: 24px;
}

.verification-title,
.success-title {
  color: #2a4fd7;
  font-weight: 700;
  margin-bottom: 8px;
  font-size: 18px;
}

.verification-subtitle {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
}

.success-icon {
  width: 50px;
  height: 50px;
  background: #10b981;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  margin: 0 auto 16px;
  animation: successPulse 2s ease-in-out infinite;
}

.success-message {
  color: #6b7280;
  line-height: 1.6;
  font-size: 14px;
  margin-bottom: 0;
}

// Estilos para a versão genérica
.modern-card {
  border-radius: 20px;
  background: white !important;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
}

.logo-image {
  max-width: 280px;
  height: auto;
}

.logo-image-small {
  max-width: 200px;
  height: auto;
}

.card-title {
  color: var(--corPrimaria);
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 8px;
}

.card-subtitle {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 0;
}

.success-icon-large {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  margin: 0 auto;
  animation: successPulse 2s ease-in-out infinite;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
}

.success-message-large {
  color: #4b5563;
  line-height: 1.6;
  font-size: 16px;
  max-width: 400px;
  margin: 0 auto;
}

@keyframes successPulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 30px rgba(16, 185, 129, 0.4);
  }
}

// Responsividade aprimorada
@media screen and (max-width: 768px) {
  .modern-card .v-card-text {
    padding: 24px 20px !important;
  }

  .logo-image {
    max-width: 220px;
    padding: 16px;
  }

  .logo-image-small {
    max-width: 160px;
    padding: 12px;
    border-radius: 10px;
  }

  .card-title {
    font-size: 20px;
  }

  .success-icon-large {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
}

@media screen and (max-width: 480px) {
  .modern-card .v-card-text {
    padding: 20px 16px !important;
  }

  .d-flex.gap-3 {
    flex-direction: column;
    gap: 12px;
  }

  .d-flex.gap-3 .v-btn {
    width: 100%;
  }

  .logo-image {
    max-width: 180px;
    padding: 12px;
    border-radius: 10px;
  }

  .logo-image-small {
    max-width: 140px;
    padding: 10px;
    border-radius: 8px;
  }

  .verification-title,
  .success-title {
    font-size: 16px;
  }
}

// Borda superior com cor primária nos cards modernos
.modern-card {
  border-top: 4px solid var(--corPrimaria, #2a4fd7) !important;
}
</style>
